/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { error, errorNoInspect };
function errorNoInspect(graphId) {
    return error(`Unable to inspect graph with the id of "${graphId}"`);
}
function error(message) {
    return {
        success: false,
        error: message,
    };
}
//# sourceMappingURL=error.js.map